import { Link } from '@/theme/ui'
import s from './logo.module.scss'
import {Karavan} from "@/theme/assets/icons";
import cn from "classnames";

export const Logo = ({mobile}) => {
    return (
        <>
            <div className={cn(s.logo, mobile ? s.mobile : '')}>
                <Link href={'/'}>
                    <Karavan />
                </Link>
            </div>
        </>
    )
}